$(document).ready(function(){
  var last = $('.product__info-container').children().last(),
    secondLast = last.prev();
  
  var newDiv = $('<div class="last_div"></div>');

  // Append the selected elements to the new div
  newDiv.append(secondLast).append(last);

  // Append the new div back to the container
  $('.product__info-container').append(newDiv);
// });

// function changeATCText(variant){
//   var selectVariant = variant;
//   console.log('selectVariant',selectVariant)
//   setTimeout(function(){
//     console.log('here we go')
//     if(selectVariant){
//     var var_meta = variant_meta.filter((v)=>{return v.id == selectVariant.id});
//     if(var_meta.length>0){
//     console.log('var_meta',var_meta,var_meta[0].value)
//     $('form.shopify-product-form button.product-form__submit').each(function(indx,ele){
//       $(ele).text(var_meta[0].value);
//     })
//     }
//   }  
//   },1000)
// }
// document.addEventListener("variant:init", function(evt){
//   var selectVariant = evt.detail.variant;
//   console.log('vairant init',selectVariant)
//   changeATCText(selectVariant);
// })
// document.addEventListener("variant:change", function(evt){
//   // console.log('variant change ',evt)
//   var selectVariant = evt.detail.variant;
//   changeATCText(selectVariant);
  
});